/*
 * サブシステム名：請求
 * 機能名：請求備考入力（ダイアログ）
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButton from '@/components/DdIconButton'
import DdTextArea from '@/components/DdTextArea'
import flowMixin from '@/mixins/flowMixins'

export default {
  name: 'SeikyuBikoEditDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdIconButton,
    DdTextArea
  },
  props: {
    showDialog: Boolean,
    id: 0,
    seikyuKihon: {},
    modeKengen: 0
  },
  data: () => ({
    invalidMessages: {}
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0) {
        return true
      }
      return false
    }
  },
  methods: {
    onCloseButtonClick: function (e) {
      this.$emit('close')
    },
    onSaveButtonClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      if (!isValid) { return }

      return new Promise(resolve => {
        this.HttpClient.put(`/api/v1/TrSeikyuKihon/Update?id=${this.id}`, this.seikyuKihon)
          .then((data) => {
            this.$emit('close', data)
            resolve()
          })
      })
    }
  }
}
